export class BrandResponse {
    Logo: string | null;
    Label: string | null;
    Keywords:string | null;
    Link: string | null;
    PrimaryColor: string | null;
    SecondaryColor: string | null;
    BarColor: string | null;
}